@use "../../../../tti-design-styles/src/molecules/envribbon" as *;

:host { display: block; }